import {
  getPlanes as axiosGetPlanes,
  getPlanesByEmail as axiosGetPlanesByEmail,
  getPreciosPlanesByEdadMascota as axiosGetPreciosPlanesByEdadMascota,
} from '../../axios/Plan';
import { useUser } from '../../context/UserContext';
import { PetPlanReq, Plan } from '../../types/Plan/types';
import { useFetchEntity } from '../Utils/useEntity';

/* ========================================
 * PLANES GENERALES
 * ====================================== */
const useGetPlanes = (enabled?: boolean) => {
  const shouldFetch = enabled ?? true;

  const {
    data: planes,
    isValidating,
    error,
    mutate,
  } = useFetchEntity<Plan[]>(shouldFetch ? 'planes' : null, async () => {
    const res = await axiosGetPlanes();
    return res.success ? res.data : undefined;
  });

  return { planes, isValidating, error, mutate };
};

/* ========================================
 * PLANES POR MASCOTA
 * ====================================== */
const useGetPlanesByMascota = (enabled?: boolean, nombre?: string) => {
  const { user } = useUser();
  const email = user?.email ?? '';
  const shouldFetch = enabled ?? !!email;

  const {
    data: planes,
    isValidating,
    error,
    mutate,
  } = useFetchEntity<PetPlanReq[]>(
    shouldFetch && email ? 'planesByMascota' : null,
    async () => {
      const res = await axiosGetPlanesByEmail(email);
      return res.success ? res.data : undefined;
    },
  );

  const planMascota = nombre ? planes?.find((plan) => plan.nombre === nombre) : undefined;

  return { planes, planMascota, isValidating, error, mutate };
};

/* ========================================
 * PRECIOS POR EDAD DE MASCOTA
 * ====================================== */
const useGetPreciosPlanesByEdadMascota = (edadMascota?: number, enabled?: boolean) => {
  const shouldFetch = (enabled ?? true) && typeof edadMascota === 'number';

  const key = shouldFetch ? `preciosPlanesByEdadMascota-${edadMascota}` : null;

  const {
    data: preciosPlanes,
    isValidating,
    error,
    mutate,
  } = useFetchEntity<string[]>(key, async () => {
    return await axiosGetPreciosPlanesByEdadMascota(edadMascota!);
  });

  return { preciosPlanes, isValidating, error, mutate };
};

export { useGetPlanes, useGetPlanesByMascota, useGetPreciosPlanesByEdadMascota };
